// -*- Mode: rjsx -*-
import React from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import PaymentIcon from '@mui/icons-material/Payment';

import { ResponseOption } from '..';
import { FancyTextEntry } from '../../../ui';

function PurchaseSheet(props) {
    return <FancyTextEntry />;
}


function PurchaseResponse(props) {
    props = {
        type: "purchase",
        primary: "Request payment approval",
        secondary: "We need to make a purchase",
        icon: <PaymentIcon />,
        ...props
    };    
    return (
        <ResponseOption
          {...props}
          sheet={<PurchaseSheet {...props}  />}
        />
    );
}



export { PurchaseResponse };
